module.exports = __webpack_public_path__ + "static/img/ai-banner-m.bebb8b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai-banner-m.png
// module id = l0e0
// module chunks = 0